<template>
  <div
      class="order-timeline">
    <div class="order-timeline-heading">
      Order Timeline
    </div>
    <div class="order-timeline-content">
      <div id="order-timeline-statuses">
        <OrderTimelineStatus
            v-for="(status, idx) in timeline"
            :key="idx"
            v-bind="status"
            @return-id="sendReturnID"
            @return-created="showReturnOrder" />
      </div>
    </div>
  </div>
</template>

<script>
import OrderTimelineStatus from "./OrderTimelineStatus.vue";
import moment from "moment-timezone";
import "../../../assets/order_timeline_heading.css";

export default {
  name: "OrderTimeline",
  components: { OrderTimelineStatus },
  props: {
    order: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      x: 0,
      timeline: [],
    };
  },
  mounted() {
    this.loadTimeline();
  },
  methods: {
    moment,
    showReturnOrder(value) {
      this.$emit("return-created", value);
    },
    sendReturnID(value) {
      this.$emit("return-id", value);
    },
    loadTimeline() {
      let timeline = [
        ...this.getOrderReceivedEvent(),
        ...this.getShippedEvents(),
        ...this.getCancelledEvent(),
        ...this.getReturnEvents(),
      ];
      this.timeline = timeline.sort(
        this.sortByPropertyDesc("dateTime", "statusName")
      );
    },
    getCancelledEvent() {
      if (this.order.order.cancelled_by !== null) {
        let cancelled_by =
          this.order.order.cancelled_by.user != null
            ? "customer"
            : "fulfillment center";
        return [
          {
            statusName: "Cancelled",
            subtext: "Order cancelled by " + cancelled_by,
            subtext2: null,
            dateTime: this.order.order.updated_at,
          },
        ];
      } else {
        return [];
      }
    },
    getReturnEvents() {
      let return_events = [];
      for (let return_order of this.order.return_orders || []) {
        let return_event = {
          statusName: "Return Created",
          subtext: return_order.id.toString(),
          subtext2: null,
          dateTime: return_order.created_at,
        };
        return_events.push(return_event);
      }
      return return_events;
    },
    getShippedEvents() {
      let x = 0;
      let shipped_events = [];
      for (let shipment of this.order.shipments) {
        x += shipment.shipment_packages.length;
        for (let shipment_package of shipment.shipment_packages) {
          let est_date = shipment_package.estimated_arrival_date;
          let tz = this.$store.getters["ui/currentTimezone"];
          est_date = this.$moment.tz(est_date, tz).format("MMM DD, YYYY");
          let shipped_event = {
            statusName: "Shipped",
            subtext: shipment_package.tracking_number,
            subtext2: "Estimated arrival: " + est_date.toString(),
            dateTime: shipment.shipping_date,
          };
          shipped_events.push(shipped_event);
        }
      }
      this.x = x;
      shipped_events = shipped_events.sort(this.sortByPropertyAsc("dateTime"));
      for (let [index, shipped_event] of shipped_events.entries()) {
        shipped_event.statusName =
          "Shipped (" + (index + 1).toString() + "/" + this.x.toString() + ")";
      }
      return shipped_events;
    },
    getOrderReceivedEvent() {
      return [
        {
          statusName: "Order Received",
          subtext: "This order was made at ring.com",
          subtext2: null,
          dateTime: this.order.order.created_at,
        },
      ];
    },
    sortByPropertyDesc(property1, property2) {
      return function (a, b) {
        if (a[property1] > b[property1]) return -1;
        else if (a[property1] < b[property1]) return 1;
        else {
          if (a[property2] > b[property2]) return -1;
          else if (a[property2] < b[property2]) return 1;
        }
        return 0;
      };
    },
    sortByPropertyAsc(property1) {
      return function (a, b) {
        if (a[property1] > b[property1]) return 1;
        else if (a[property1] < b[property1]) return -1;
        return 0;
      };
    },
  },
};
</script>

<style>
.order-timeline-heading {
  font-family: "Equip", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 36px;
  margin-bottom: 8px;
}
.order-timeline {
  margin-bottom: 64px;
}
</style>
